export default {
  shadow: {
    boxShadow: '2px 3px 5px 2px rgba(0, 0, 0, 0.5)',
    borderRadius: 10,
  },
  darkShadow: {
    boxShadow: '4px 5px 12px 2px rgba(0,0,0,0.76)'
  },
}
